"use strict";
/*
 * Created on 15.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * @author MSu
 */


var EntityChangeSetInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityChangeSetInfo, _DomainObject_1$Domai);

  function EntityChangeSetInfo(id, user, changeDate, changeType, entityClass, oldState, newState) {
    var _this;

    _classCallCheck(this, EntityChangeSetInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityChangeSetInfo).call(this));
    _this.id = id;
    _this.user = user;
    _this.changeDate = changeDate;
    _this.changeType = changeType;
    _this.entityClass = entityClass;
    _this.oldState = oldState;
    _this.newState = newState;
    return _this;
  }

  return EntityChangeSetInfo;
}(DomainObject_1.DomainObject);

exports.EntityChangeSetInfo = EntityChangeSetInfo;